import '@/icons/cloudHome.js'
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import UAParser from 'ua-parser-js';
// import Vconsole from 'vconsole';
import store from './store';

import {
    InfiniteScroll,
    Tooltip,
    Loading,
    Scrollbar,
    Dropdown,
    Input,
    DatePicker,
    Button,
    DropdownMenu,
    DropdownItem,
    Toast,
    Message,
    Dialog,
    Popover,
    Tree,
    Checkbox,
    Drawer,
    Switch,
    Menu,
    MenuItem,
    Submenu,
    MenuItemGroup,
    Table,
    TableColumn,
} from '@moore/moore-pc-toca'
import '@moore/moore-pc-toca/lib/theme-chalk/toast.css'
import '@moore/moore-pc-toca/lib/theme-chalk/index.css'
import Tci18nVue2, { useI18n } from 'tci18n-vue2';
const { lang } = useI18n();
store.dispatch('setCloudHomeI18n', lang);

Vue.prototype.$ua = UAParser([navigator.userAgent]);
Vue.config.productionTip = false;

Vue.prototype.$toast = Toast
Vue.use(Table)
Vue.use(Tooltip)
Vue.use(TableColumn)
Vue.use(MenuItem)
Vue.use(Menu)
Vue.use(InfiniteScroll)
Vue.use(Loading)
Vue.use(Scrollbar)
Vue.use(Dropdown)
Vue.use(Button)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Popover)
Vue.use(DatePicker)
Vue.use(Tree)
Vue.use(Checkbox)
Vue.use(Drawer)
Vue.use(Switch)
Vue.use(Submenu)
Vue.use(MenuItemGroup)
Vue.use(Tci18nVue2, {
    locale: __tci18n_locale__,
    langs: __tci18n_langs__
});

Vue.prototype.$message = Message
Vue.prototype.$menu = Menu

// if (process.env.VUE_APP_STATIC_NODE_ENV !== 'production') {
//   Vue.use(new Vconsole());
// }

new Vue({
    router,
    store,
    i18n: Vue.prototype.tci18n,
    render: h => h(App),
}).$mount('#app');
